<template>
  <div>
    <SkeletonLoaderTitleUpdate v-show="showSkeleton" />

    <div class="ma-4 text-h4" v-show="!showSkeleton">Atualizar Usuário - {{ nome }}</div>

    <div v-if="canRender">
      <CadastroUsuario edicao="true" :id="id" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import { registerVuexModule } from '@/utils/vuexUtils'
import SkeletonLoaderTitleUpdate from '@/componentes/SkeletonLoaderTitleUpdate'

import usersStore from '../_store'

import CadastroUsuario from './CadastroUsuario'

export default {
  name: 'AtualizarUsuario',
  props: {
    id: String,
  },
  components: { CadastroUsuario, SkeletonLoaderTitleUpdate },

  data: () => ({
    nome: '',
    showSkeleton: false,
    canRender: false,
  }),

  computed: {
    ...mapGetters('atualizarUsuarioModuleUsersStore', ['getSpecificUser']),
  },

  async created() {
    this.showSkeleton = true

    registerVuexModule(this.$store, 'atualizarUsuarioModuleUsersStore', usersStore)
    await this.listSpecificUser(this.id)
    this.nome = this.getSpecificUser.name

    this.showSkeleton = false
    this.canRender = true
  },

  methods: {
    ...mapActions('atualizarUsuarioModuleUsersStore', ['listSpecificUser']),
  },
}
</script>
